
<!-- TODO: On doit forcer une largeur maximal de 1600px pour les listes horizontales -->
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <template v-if="isVisible">
    <b-container
      v-if="
        (mixinEnvironnement_inEditor || arrElementListeHorizontale.length) &&
        !isCarteListeUnElement &&
        contentTitre.titre
      "
      fluid
      class="d-flex justify-content-center px-sm-4 info-titre m-0 px-2 pt-3"
    >
      <b-row class="w-100">
        <b-col
          v-if="content.afficherZoneEscamotable === 'true'"
          cols="8"
          class="titre-liste graphik_black zoneEscamotable py-2 px-1 px-lg-2 text-left w-100"
          @click="toggleZoneEscamotable"
        >
          <Titre :content="contentTitre" />
        </b-col>
        <b-col v-else cols="8" class="titre-liste px-1 px-lg-2 graphik_black">
          <b-link
            v-if="isLienListeHorizontaleVisible"
            v-bind="jel_getLienBinding(content.lien)"
            class="d-flex"
          >
            <Titre :content="contentTitre" />
            <b-icon scale="0.7" icon="chevron-right"></b-icon>
          </b-link>
          <div v-else>
            <Titre :content="contentTitre" />
          </div>
        </b-col>
        <b-col
          v-if="content.libLien && !jel_getLienBinding(content.lien).disabled"
          class="libelle-liste text-right pr-0 pr-sm-1"
        >
          <b-link v-bind="jel_getLienBinding(content.lien)" class="graphik_medium texte-lien"
            >{{ content.libLien }}
          </b-link>
        </b-col>
      </b-row>
    </b-container>
    <template v-if="mixinEnvironnement_inEditor">
      <div class="container">
        <div class="row">
          <EditableArea
            :content="getContentEditableArea()"
            :parentTemplateId="metadata['mgnl:template']"
          />
        </div>
      </div>
    </template>

    <WithRoot :show="content.afficherZoneEscamotable === 'true'">
      <div class="panneau" :class="[zoneEscamotableOuvert ? 'd-flex' : 'd-none']">
        <vue-horizontal-list
          v-if="arrElementListeHorizontale.length"
          ref="listeHorizontale"
          :reduireItemsVHL="!isMediaImageLogoProduitCasino3x4"
          :itemMinWidth="itemMinWidth"
          :items="arrElementListeHorizontale"
          :options="getOptions()"
        >
          <template #default="{ item }">
            <component :is="item.componentName" :content="item" />
          </template>
        </vue-horizontal-list>
      </div>
    </WithRoot>
  </template>

  <div
    v-else
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
    class="chargement"
  >
    <span> {{ $t('chargement') }} {{ content.titre }}...</span>
  </div>
</div>
